import type { PROMOTION_TYPES } from '@/domainLogic/index.ts';

export const HOTEL_THEME = 'HOTEL_THEME' as unknown as PROMOTION_TYPES;
export const KIDS_STAY_FREE = 'KIDS_STAY_FREE' as unknown as PROMOTION_TYPES;
export const WELCOME_GIFT_OFFER = 'WELCOME_GIFT_OFFER' as unknown as PROMOTION_TYPES;
// The MyPrice percentage sits in a different slot than the label, so it travels as its own type.
export const MY_PRICE_DISCOUNT = 'MY_PRICE_DISCOUNT' as unknown as PROMOTION_TYPES;
